import RankingStat from '../../entities/RankingStat.js';
import PitchingRankingStats from '../../enums/PitchingRankingStats.js';
import NumberFormatter from '../../formatters/NumberFormatter.js';
import SelectiveRankingStatCalculatorBase from './SelectiveRankingStatCalculatorBase.js';

class EarnedRunsAverageRankingStatCalculator extends SelectiveRankingStatCalculatorBase {
    constructor(numberFormatter) {
        if (typeof(numberFormatter) !== 'undefined' && !(numberFormatter instanceof NumberFormatter)) {
            throw new TypeError('numberFormatter must be an instance inheriting from NumberFormatter class');
        }
        super([
            PitchingRankingStats.EarnedRunsAverage
        ]);

        this.dependencies = [PitchingRankingStats.EarnedRuns, PitchingRankingStats.OutsPitched];
        this.numberFormatter = numberFormatter || new NumberFormatter(3);
    }

    listDependencies(parameter) {
        // TODO - maybe concat ?
        return this.dependencies;
    }

    calculateStat(parameter, dependencies) {
        const [ erRs, opRs ] = dependencies;
        if (
            !erRs || erRs.isEmpty() // TODO - maybe set 0 when no earned runs ?
            || !opRs || opRs.isEmpty()
        ) {
            return null;
        }

        // @see https://baseball.fandom.com/wiki/Earned_run_average
        // @see https://www.mlb.com/glossary/standard-stats/earned-run-average
        // In baseball statistics, earned run average (ERA) is the mean of earned runs given up by a pitcher per nine innings pitched.
        // It is determined by multiplying the number of earned runs allowed by nine and dividing by the number of innings pitched.
        const ip = opRs.value / 3;
        const er = er.value;
        const era = (9 * er) / ip;
        return RankingStat.fromParameter(
            parameter, this.numberFormatter.format(era), opRs.value
        );
    }
}

export default EarnedRunsAverageRankingStatCalculator;